import { Typography } from "@mui/material";

import BetaPill from "@/Components/v2/atoms/Pill/BetaPill";
import Tooltip from "@/Components/v2/atoms/ToolTip/Tooltip";

interface BetaPillWithTooltipProps {
  title: string;
}

export const BetaPillWithTooltip: React.FC<BetaPillWithTooltipProps> = ({ title }) => {
  return (
    <Tooltip
      title={
        <Typography variant="body2" p={1}>
          {title}
        </Typography>
      }
    >
      <span>
        <BetaPill withTooltip />
      </span>
    </Tooltip>
  );
};

export default BetaPillWithTooltip;
